export default __webpack_public_path__ + "static/media/G89A3675_tn.e7ad890b.jpg";